import React from "react";
import FilterChipGroup from "../filterChip/filterChipGroup";
import FilterChip from "../filterChip";
import { titleCase } from "../../utils";

interface FilterChipConfig {
    title: string;
    items: string[];
    maxVisible: number;
    onClose: (item: string) => void;
    renderChip?: (item: string) => React.ReactNode;
}

interface FilterChipListProps {
    filters: FilterChipConfig[];
}

const FilterChipList: React.FC<FilterChipListProps> = ({ filters }) => (
    <>
        {filters.map(({ title, items, maxVisible, onClose, renderChip }) => (
            items?.length > 0 && (
                <FilterChipGroup
                    key={title}
                    title={title}
                    items={items}
                    maxVisible={maxVisible}
                    renderChip={
                        renderChip ||
                        ((item) => (
                            <FilterChip
                                key={item}
                                title={title}
                                label={titleCase(item, true)}
                                onClose={() => onClose(item)}
                            />
                        ))
                    }
                />
            )
        ))}
    </>
);

export default FilterChipList;
